import { axMobileMenu as mobileMenu } from './js/custom/mobile-menu';
// import { axSlickSlider as slider } from './js/custom/sliders';

// import {
// 	axTippyHtmlContent as tooltipHtmlContent,
// 	axTippyBasic as tooltipBasic,
// } from './js/custom/tippy';

import { axIntersectionObserver } from './js/custom/intersection-observer';

// import {
// 	axAccordionToggle,
// } from './js/custom/accordion';

// import {
// 	axCheckSticky
// } from './js/custom/utility';


// Document Ready
document.addEventListener( 'DOMContentLoaded', function () {
    // console.log( 'invoke' );

    // Mobile Menu
    mobileMenu();

    // Slick Slider
    // slider(
    //     '.js-carousel-testimoinals',
    // );

    // Modaal Inline
    // modalBasic( '[data-modal="inline"]' );

    // Modaal Ajax
    // modalAjax( '.js-modal-ajax' );

    // Modal Video
    // modalVideo( '.ax-modal-video a' );

    // Modal Inline
    // modalInline( '.js-modal-inline' );
    // modalInline( '.js-modal-inline-gtb-button a' );

    // Tippy Dropdown
    // dropdownMenu( '.ax-context-menu-trigger' );

    // // Tippy Basic
    // tooltipBasic( '[data-tippy-content]' );

    // // Tippy HTML Content
    // tooltipHtmlContent( '[data-template]' );

    // Check Sticky
    // axCheckSticky( '.site-header', 'header-is-sticky' );

    // Observer
    axIntersectionObserver(
        '.ax--animation-viewport',
        'ax--animate',
        false
    );

    // Animated SVG
    // axIntersectionObserver( '.ax-svg-animate', 'start-animation', false );

    // Accordion
    // axAccordionToggle( '.ax-accordion-toggle' );
} );
